<template>
  <v-tooltip bottom max-width="340">
    <template v-slot:activator="{ on, attrs }">
      <span class="column-help" v-bind="attrs" v-on="on">
        {{ label }}<v-icon x-small class="ml-1 column-help-icon">mdi-help-circle-outline</v-icon>
      </span>
    </template>
    <div class="text-caption">
      <div v-if="formula" class="font-weight-bold mb-1">{{ formula }}</div>
      <div>{{ text }}</div>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "ColumnHelp",
  props: {
    label: { type: String, required: true },
    formula: { type: String, default: "" },
    text: { type: String, required: true }
  }
};
</script>

<style scoped>
.column-help {
  border-bottom: 1px dotted currentColor;
  cursor: help;
  white-space: nowrap;
}
.column-help-icon {
  vertical-align: baseline;
  opacity: 0.6;
}
</style>
